/**
 * WhatsApp utility functions for eAuditor
 */

/**
 * Generates WhatsApp URL for business contact
 * @param {string} phoneNumber - Phone number in international format (e.g., '19197711510')
 * @param {string} message - Pre-filled message (default: 'eAuditor')
 * @returns {string} WhatsApp API URL
 */
export const generateWhatsAppUrl = (phoneNumber = '19197711510', message = 'eAuditor') => {
    const encodedMessage = encodeURIComponent(message)
    return `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`
}

/**
 * Opens WhatsApp chat in new tab/window
 * @param {string} phoneNumber - Phone number in international format
 * @param {string} message - Pre-filled message
 */
export const openWhatsAppChat = (phoneNumber = '19197711510', message = 'eAuditor') => {
    const url = generateWhatsAppUrl(phoneNumber, message)
    window.open(url, '_blank', 'noopener,noreferrer')
}

/**
 * App Store URLs for eAuditor mobile apps
 */
export const APP_STORE_URLS = {
    GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.eauditor',
    APP_STORE: 'https://apps.apple.com/us/app/eauditor-audits-inspections/id1558915087',
}
